import { IServiceProvider } from "./../../../models/serviceprovider";
import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IServiceProviderState } from ".";
import { IRootState } from "@/store/types";
import { SProvidersMutationsNames } from "./enums";

export const actions: ActionTree<IServiceProviderState, IRootState> = {
    fetchServiceProviders({ commit }): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "serviceproviders"
                )
            )
            .then((response) => {
                if (response.status === 200) {
                    const serviceProviderList = response.data.serviceProviders.sort(
                        (a: IServiceProvider, b: IServiceProvider) => {
                            var nameA = a.businessName!.toUpperCase();
                            var nameB = b.businessName!.toUpperCase();
                            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                        }
                    );
                    // mutation to storage sp list
                    commit(
                        SProvidersMutationsNames.SetList,
                        serviceProviderList
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(SProvidersMutationsNames.SetError, error);
            });
    },
    setSelectedServiceProvider(
        this,
        { commit },
        serviceProvider: IServiceProvider
    ) {
        commit(SProvidersMutationsNames.SetSelected, serviceProvider);
    },
    resetServiceProviderState({ commit }): void {
        commit(SProvidersMutationsNames.ResetState);
    },
};
